import React, { useEffect } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import Actions from "../../Redux/Actions"
import { WithDrawerConsumer } from "../../Contexts/DrawerContext/withDrawerConsumer"
import SecondaryNavDrawer from "../SecondaryNavDrawer/SecondaryNavDrawer"
import MobileNavItem from "../MobileNavItem/MobileNavItem"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"

const resolveWorkshopCourseContext = (location, user) => {
  const qs = queryString.parse(location.search)
  const courseIdFromQuery = qs.courseId ? Number(qs.courseId) : null
  const courseId = location.state?.courseId ?? courseIdFromQuery ?? null
  let courseName = location.state?.courseName

  if (!courseName && Number(courseId) === ADDITIONAL_COURSE_ID) {
    const enrolled = user?.enrolled_courses?.find(
      (c) => Number(c.id) === ADDITIONAL_COURSE_ID
    )
    courseName = enrolled?.name
  }

  if (!courseName) {
    courseName = "Pursue Your Purpose"
  }

  return { courseId, courseName }
}

export const PYPNavDrawer = (props) => {
  const isLoading = !props.initialized && !props.modules.length
  const { courseId, courseName } = resolveWorkshopCourseContext(
    props.location,
    props.user
  )
  const drawerTitle =
    props.currentCourseName || courseName || "Pursue Your Purpose"

  useEffect(() => {
    props.initializePYP(
      props.match.params.module || "Welcome to COMMIT",
      courseName,
      courseId
    )
  }, [])

  const processOptions = (option) => {
    const useCourseId =
      courseId != null && Number(courseId) === ADDITIONAL_COURSE_ID
    return {
      ...option,
      isSelected: props.match.params.module === option.title,
      route: `/workshop/${option.title}${
        useCourseId ? `?courseId=${courseId}` : ""
      }`
    }
  }

  const addStatus = (pypModule) => {
    const unlocked = props.userModules.find((userModule) => {
      return userModule.id === pypModule.id
    })

    return {
      ...pypModule,
      isUnlocked: Boolean(unlocked)
    }
  }

  const navOptions = props.modules
    .map(processOptions)
    .map(addStatus)
    .map((option, i) => {
      return (
        <MobileNavItem
          style={{ padding: "10px 40px 10px 40px" }}
          hasSecondaryNavigation={false}
          {...option}
          key={i}
        >
          <p
            style={{
              gridColumnStart: 2,
              opacity: option.isUnlocked || option.isSelected ? 1 : 0.5
            }}
          >
            {option.title}
          </p>
        </MobileNavItem>
      )
    })

  return (
    <>
      <SecondaryNavDrawer
        navOptions={navOptions}
        title={drawerTitle}
        titleStyles={{ fontSize: "24px" }}
        isLoading={isLoading}
      />
    </>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => ({
  ...props,
  modules:
    state.pyp.modules && state.pyp.modules.allIds
      ? state.pyp.modules.allIds.map(
          (moduleId) => state.pyp.modules.byId[moduleId]
        )
      : [],
  userModules: state.user.user.modules,
  user: state.user.user,
  currentCourseName: state.pyp.navigation.currentCourseName,
  initialized: state.pyp.initialized
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WithDrawerConsumer(PYPNavDrawer))
)
